<template>
  <MainWrapper>
    <div class="single-master-page">
      <div class="container">
        <h3 class="mb-30">Прайс-лист</h3>
        <div class="white-panel">
          <div class="container-fluid">
            <div class="row mb-5 table-header">
              <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                Тип услуги
                <p class="desc mt-5">Тип оказываемой услуги</p>
              </div>
              <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                Стоимость
                <p class="desc mt-5">Стоимость за единоразовое посещение</p>
              </div>
              <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                Длительность
                <p class="desc mt-5">Примерная длительность оказания услуги</p>
              </div>
            </div>
            <div class="row" v-for="s in specInfo.service" :key="s.id">
              <div class="col-lg-3">
                <p class="dark-body-text mt-15 mb-15 mob-width">{{ s.name }}</p>
              </div>
              <div class="col-lg-3">
                <div class="mt-15 mb-15">
                  {{ s.price }}
                  <span class="som">с</span>
                </div>
              </div>
              <div class="col-lg-3 mob-ml-60">
                <div class="mt-15 mb-15">{{ s.duration }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
@import '../../styles/main.core.vars.styl';

.table-header {
  background: $main_gradient;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
}

.white-panel {
  overflow: hidden;
}

.desc {
  font-weight: 400;
  text-transform: none;
}

@media screen and (max-width: 624px) {
  .mob-width {
    max-width: 100px;
  }

  .mob-ml-35 {
    margin-left: 35px;
  }

  .mob-ml-60 {
    margin-left: 60px;
  }

  .row {
    font-size: 10px;
    display: flex;
    // justify-content: space-between;
  }

  .desc {
    display: none;
  }

  .row.table-header {
    .col {
      font-size: 8px !important;
    }
  }
}

@media screen and (max-width: 320px) {
  .row {
    font-size: 8px;
  }

  .mob-width[data-v-bef2e9a6] {
    max-width: 72px;
  }

  .mob-ml-60[data-v-bef2e9a6] {
    margin-left: 50px;
  }
}
</style>
<script>
import { Component, Vue } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Schedule from "@/components/Schedule.vue";

import moment from "moment";

import http from "@/methods/http.ts";

@Component({
  components: {
    MainWrapper,
    Button,
    Schedule,
  },
})
export default class PriceList extends Vue {
  specInfo = {
    service: [],
  };

  getSpecInfo() {
    http(`masters/${this.$route.params.slug}`, "get", false, {}).then((r) => {
      this.specInfo = r.data;
    });
  }

  created() {
    this.getSpecInfo();
  }
}
</script>